import { render } from "./PageHeaderUsageMeta.vue?vue&type=template&id=1a643b1f"
import script from "./PageHeaderUsageMeta.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHeaderUsageMeta.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/PageHeaderUsageMeta.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a643b1f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a643b1f', __exports__)) {
    api.reload('1a643b1f', __exports__)
  }
  
  module.hot.accept("./PageHeaderUsageMeta.vue?vue&type=template&id=1a643b1f", () => {
    api.rerender('1a643b1f', render)
  })

}


export default __exports__